import React from 'react';
import { observer } from 'mobx-react';
import CssDimensionNumberInput from './baseInputs/CssDimensionNumberInput';
import { extractUnit, extractValue } from '../cssUtils';
const BackgroundPositionEdit = observer(({
  value,
  setValue
}) => {
  const x_size = value.split(' ')[0];
  const y_size = value.includes(' ') ? value.split(' ')[1] : x_size;
  return /*#__PURE__*/React.createElement("div", {
    className: "single-css-property"
  }, /*#__PURE__*/React.createElement("span", {
    className: "css-property-name"
  }, "Posizione background"), /*#__PURE__*/React.createElement("span", {
    className: "css-values"
  }, /*#__PURE__*/React.createElement("span", {
    className: "single-css-value"
  }, /*#__PURE__*/React.createElement(CssDimensionNumberInput, {
    value: extractValue(x_size),
    unit: extractUnit(x_size),
    setValue: (v, unit) => {
      const newValue = `${v}${unit} ${y_size}`;
      setValue(newValue);
    },
    title: 'X'
  })), /*#__PURE__*/React.createElement("span", {
    className: "single-css-value"
  }, /*#__PURE__*/React.createElement(CssDimensionNumberInput, {
    value: extractValue(y_size),
    unit: extractUnit(y_size),
    setValue: (v, unit) => {
      const newValue = `${x_size} ${v}${unit}`;
      setValue(newValue);
    },
    title: 'Y'
  }))));
});
export default BackgroundPositionEdit;